import { ApiService } from "./NetworkHandler";
const baseUrl = '/api/v1';

export const MetaDataApi = {
    getEnums: function () {
        return ApiService.sendRequest('get', `${baseUrl}/enums-metadata`);
    },
}